/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.link-external\":\"Kvadrat med pil som pekar uppåt åt höger\"}");